import { useQuery } from '@tanstack/react-query';

import { getStates } from '@/infrastructure/network/data/lookups/states';

export const useStatesQuery = () => {
	return useQuery({
		queryKey: ['STATES'],
		queryFn: () => getStates({})
	});
};
